/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  loading: false,
  progress: 0,
  status: '',
  error: '',
  selectedKernel: null,
  showSelectModal: false
});

export default function kernelUpgradeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'LOAD_SECURITY_ROUTER_CONFIGURATION_DONE':
    case 'LOAD_CONFIGURATION_DONE': {
      return action.payload.busyWith === 'kernel.upgrade.ongoing'
        ? INITIAL_STATE.set('status', 'started')
        : INITIAL_STATE;
    }
    case 'KERNEL_UPGRADE_STARTED': {
      return state.set('status', 'started');
    }
    case 'KERNEL_UPGRADE_SELECT_VERSION': {
      return state.set('selectedKernel', action.payload.id);
    }
    case 'KERNEL_UPGRADE_HIDE_SELECT_MODAL': {
      return state.set('showSelectModal', false);
    }
    case 'KERNEL_UPGRADE_SHOW_SELECT_MODAL': {
      return state.set('showSelectModal', true);
    }
    case 'KERNEL_UPGRADE_STATUS_POLL_DONE': {
      const { progress, status } = action.payload;
      if (status !== 'failed') {
        state = state.set('status', status);
      }
      return state.set('progress', progress);
    }
    case 'KERNEL_UPGRADE_STATUS_POLL_FAILED': {
      return state.set('error', action.payload);
    }
    case 'KERNEL_UPGRADE_FAILED': {
      return state.set('error', action.payload);
    }
    default: {
      return state;
    }
  }
}
